import gql from 'graphql-tag';

export const TIME_ZONES_QUERY = gql`
  query TimeZonesQuery {
    timeZones {
      name
      offset
    }
  }
`;
